import React from 'react';
import { Box } from '../Box';

export const ModalFooter = ({ children }) => (
  <Box>
    <Box width="100%" height="1px" backgroundColor="divider" marginBottom="5" />
    <Box>{children}</Box>
  </Box>
);
